import { makeStyles, tokens } from '@fluentui/react-components';

export const useBudgetCardStyles = makeStyles({
  container: {
    '& .error': {
      color: tokens.colorPaletteCranberryBorderActive,
    },
  },
});
